// extracted by mini-css-extract-plugin
export default {"wrapper":"src_wrapper__SK4kg"};